// Client-side password policy — mirrors the backend validator in
// app/models/entities.py (_validate_password_strength + min_length=12) so the
// user gets an immediate, friendly message instead of a raw 422 from the API.
// Keep these rules in sync with the backend; the backend remains the source of
// truth and still enforces on submit.

export const PASSWORD_MIN_LENGTH = 12;

export const PASSWORD_HINT =
  "At least 12 characters, including an uppercase letter, a lowercase letter, a number, and a special character.";

// Special-character set matches the backend regex exactly.
const SPECIAL_CHAR = /[!@#$%^&*(),.?":{}|<>\-_=+[\]~`/\\]/;

/**
 * Validate a password against the platform policy.
 * Returns a single human-friendly error message, or null when the password is
 * acceptable. Order mirrors the backend so messages are consistent.
 */
export function validatePassword(password: string): string | null {
  if (!password) {
    return "Password is required.";
  }
  if (password.length < PASSWORD_MIN_LENGTH) {
    return `Password must be at least ${PASSWORD_MIN_LENGTH} characters.`;
  }
  if (!/[A-Z]/.test(password)) {
    return "Password must contain at least one uppercase letter.";
  }
  if (!/[a-z]/.test(password)) {
    return "Password must contain at least one lowercase letter.";
  }
  if (!/[0-9]/.test(password)) {
    return "Password must contain at least one number.";
  }
  if (!SPECIAL_CHAR.test(password)) {
    return "Password must contain at least one special character.";
  }
  return null;
}
